//1. Initialization
import { gsap } from "gsap";
import 'regenerator-runtime/runtime'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Offcanvas  } from 'bootstrap';   

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let body=document.querySelector("body");
let lastScrollTop = 0;
let btnToggler=document.querySelector('.navbar-custom__toggler');
let burgerMenu = document.querySelector("#hamburger")
let offcanvasRight=document.querySelector('#offcanvasRight');
let scrollToTopBtn=document.querySelector('.scrolltop-btn')
let isClosed = false;
let bsOffcanvas = new Offcanvas(offcanvasRight)


//2. Event Area
scrollToTopBtn.addEventListener('click', ()=>{  
    gsap.to(window, {duration: 0.1, scrollTo: 0,ease: "power2.inOut"});
});
btnToggler.addEventListener('click', ()=>{  
    burgerTime() 
});
offcanvasRight.addEventListener('hidden.bs.offcanvas', function () {
    closeSideMenu();
})
window.addEventListener('scroll', stickyNav);

//3. Function Area
function burgerTime() {
    if (isClosed== true) {
        closeSideMenu();
    } else {
        openSideMenu()
    }
}

function openSideMenu(){
    burgerMenu.classList.remove("closed");
    burgerMenu.classList.add("open");
    body.classList.add('no-scroll');
    bsOffcanvas.show();
    isClosed = true;
}

function closeSideMenu(){
    burgerMenu.classList.remove("open");
    burgerMenu.classList.add("closed");
    body.classList.remove('no-scroll');
    bsOffcanvas.hide();
    isClosed  = false;
}

function stickyNav(){
    const navHeader = document.querySelector('.navbar-custom');
    let currentScrollPos = window.scrollY;
    
    let whatsappBtn=document.querySelector('.whatapp-btn')
    setTimeout(function(){
        if(currentScrollPos<=0){
            navHeader.classList.remove('hide');
            navHeader.classList.remove('show');
        }
        else if(currentScrollPos > lastScrollTop){
            navHeader.classList.add('hide');
            navHeader.classList.remove('show');
        } else {
            navHeader.classList.add('show');
            navHeader.classList.remove('hide');
        }
        lastScrollTop = currentScrollPos;
    }, 100);

    if(currentScrollPos>750){
        scrollToTopBtn.classList.add('active')
        whatsappBtn.classList.add('active')
    }else{
        scrollToTopBtn.classList.remove('active')
        whatsappBtn.classList.remove('active')
    }
}